import React from "react";
import { DateConvert } from "../../../helper/DateConvert";
import { getAssetUrl } from "../../../helper/BaseUrl";

export default function BlogDetailBanner({data}) {
     if (!data?.title) return null;
     const bannerImageUrl = getAssetUrl(data?.banner_image);
  return (
    <>
      <section className="detailbanner-area">
        <img src="/assets/images/detail-banner-doted.webp" className="detailbanner-doted" alt="Blog Banner" />
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-xl-8">
              <div className="detailbanner-header">
                <h1 className="heading">{data?.title} </h1>
                <small>{DateConvert(data?.date)}</small>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="blog-detail-banner">
               {bannerImageUrl && <img src={bannerImageUrl} alt={data?.alt_banner_image || data?.title || "Blog banner"} />}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
